import React from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';

export default function Header() {
  const { user, logout } = useAuth();

  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  };

  return (
    <header className="bg-surface border-b border-outline-variant px-6 py-3">
      <div className="flex justify-end items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-primary-600 text-white rounded-full flex items-center justify-center font-semibold text-sm">
            {getInitials(user?.name || '')}
          </div>
          <div>
            <p className="text-sm font-semibold text-on-surface">{user?.name || ''}</p>
            <p className="text-xs text-on-surface-variant">
              {user?.role?.replace('FMPS-', '') || ''}
            </p>
          </div>
        </div>

        <div className="w-px h-8 bg-outline-variant" />

        <button
          onClick={logout}
          className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-error bg-error-light hover:bg-error hover:text-white rounded-lg transition-colors"
        >
          <FaSignOutAlt className="text-sm" />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}
